import Slider from "react-slick";
import styled from "styled-components";

export const StyledSlider = styled(Slider)`
  height: 100%;

  .slick-dots-custom {
    position: absolute;
    display: flex !important;
    justify-content: center;
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;

    li {
      width: 6px;
      height: 6px;
      margin: 0 4px;

      button {
        width: 6px;
        height: 6px;
        padding: 0;
        font-size: 0;
        background: #919191;
        border-radius: 50%;
        transition: background 0.3s ease;

        &::before,
        &::after {
          display: none;
          content: none;
        }
      }

      &.slick-active {
        margin: 0 3px;
        width: 8px;
        height: 8px;

        button {
          background: #f98723;
          width: 8px;
          height: 8px;
        }
      }
    }
  }
`;

export const MainBannerWrapper = styled.div`
  display: flex;
  color: white;
  position: relative;
  border-radius: 24px;
  background-image: url(/banner-star.svg);
  background-repeat: no-repeat;
  background-position: -85px 170px;
  background-color: var(--background-common);
  overflow: hidden;
  height: 460px;

  @media (max-width: 1400px) {
    grid-column: 1 / 2;
  }

  @media (max-width: 768px) {
    margin-bottom: 0;
    background-size: 640px;
    background-position: -180px 190px;
  }
`;

export const BannerStarWrap = styled.div`
  display: flex;
  flex-grow: 1;
  padding: 45px 0 36px 51px;
  background-image: url(/banner-img.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;

  @media (max-width: 768px) {
    padding: 40px 0 30px 16px;
    background-size: 230px;
    background-position: calc(100% + 30px) bottom;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  z-index: 1;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 470px;
`;

export const AdvertisingBanner = styled.a`
  display: flex;
  color: white;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  height: 460px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
